import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Avatar,
  Divider,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from "@mui/material";
import ProjectsIconOnline from "../../../../images/ProjectIcon.svg";
import { getBasicTopProjects } from "../../../../services/webServices.js";

const BasicProjectsLeaderBoard = () => {
  const [topProjects, setTopProjects] = useState([]);

  const fetchFilteredProjects = async () => {
    try {
      const response = await getBasicTopProjects({});
      const sorted = [...response.data.data]
        .sort((a, b) => b.tokens_used - a.tokens_used)
        .slice(0, 16);
      setTopProjects(sorted);
    } catch (error) {
      console.error("Failed to fetch project leaderboard:", error);
    }
  };

  useEffect(() => {
    fetchFilteredProjects();
  }, []);

  return (
    <Card
      sx={{
        // width: "100%", // Make it flexible inside Grid
        backgroundColor: "#F8F9FF",
        borderRadius: "12px",
        boxShadow: `4px 4px 10px #A4A4A44D, -4px -4px 10px #A4A4A44D`,
        p: { xs: 1.5, md: 2 }, // Responsive padding
        minHeight: 350,
        maxHeight: { xs: "auto", md: 400 }, // Fixed height for md+, flexible for mobile
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
      }}
    >
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Typography variant="subtitle1" fontWeight="bold">
          Top Projects
        </Typography>
      </Box>

      <Divider
        sx={{
          mt: 1,
          mb: 1,
          width: "100%",
          borderColor: "#e0e0e0",
        }}
      />

      <CardContent sx={{ p: 0 }}>
        {/* Top 3 projects */}
        {topProjects.slice(0, 3).map((proj, index) => (
          <Box
            key={proj.Project_Name}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              px: 2,
              py: 1.2,
              my: 1,
              width: "85%",
              mx: "auto",
              backgroundColor: "#f9f9fb",
              border: "1px solid #e0e0e0",
              borderRadius: "8px",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Avatar
                src={ProjectsIconOnline}
                sx={{ width: 28, height: 28, mr: 1.5 }}
              />
              <Typography fontWeight="bold" fontSize="14px">
                {proj.Project_Name}
              </Typography>
            </Box>
            <Typography fontWeight="bold" fontSize="14px" color="#000000">
              {Math.floor(proj.tokens_used / 100)} pts
            </Typography>
          </Box>
        ))}

        {/* Divider before remaining projects */}
        <Divider sx={{ mt:3,  borderColor: "#e0e0e0" }} />

        {/* Remaining projects */}
        {topProjects.slice(3, 6).map((proj, index) => (
          <Box key={proj.Project_Name}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                px: 10,
                py: 1.2,
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontWeight: "bold",
                  fontSize: "14px",
                  lineHeight: 1.8,
                  color: "#848282ff",
                }}
              >
                {proj.Project_Name}
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  fontWeight: 450,
                  fontSize: "14px",
                  color: "#848282ff",
                }}
              >
                {Math.floor(proj.tokens_used / 100)} pts
              </Typography>
            </Box>

            <Divider sx={{ borderColor: "#e0e0e0", mx: 0 }} />
          </Box>
        ))}
      </CardContent>
    </Card>
  );
};

export default BasicProjectsLeaderBoard;
